import type { FaireProductEntity } from "../../entity_types/product";

export const p_5xk8558xgt: FaireProductEntity = {
  token: "p_5xk8558xgt",
  type: "product",
  name: "10 assorted mini hearts bundle F67G * random pick",
  brandToken: "b_yrt8x5m6m6",
  brandName: "The 7 Directions",
  imageUrl:
    "https://cdn.faire.com/fastly/58c272e108f7a5a2e646f5dd0540db41b31b515445259ff7440019213e33fffa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9f70aa6c3136737c2faebbd3b8e5cafeb72c76ad1a1c06ed3884e04905e28b36.jpeg",
    "https://cdn.faire.com/fastly/9be74b5adafee109c8fd70a750ab6e2ead0d826e31118f60a66141272ae7a45e.jpeg",
  ],
  priceDollars: 6.93,
  description:
    '10 assorted mini hearts bundle F67G * random pick\n** PLEASE NOTE ** THEY DON"T COME WITH MEANING CARDS **\n\nThese are Xsmall size hearts \n0.80 " / 20mm\n\nPlease check size before purchase\nThese are random picks , assorted set\nThe pictures are for reference\n\n',
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:12.445Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
